import {
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpProgressEvent,
    HttpEventType
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { of } from 'rxjs/observable/of';
import { concat } from 'rxjs/observable/concat';
import { delay } from 'rxjs/operators/delay';
import { ToastrService, ConfirmationDialogComponent } from "../../index";
import { Helpers } from "../../auth/helpers";
import { RedirectURLService } from '../../auth/redirect-url.service';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
    constructor(private router: Router, private toastr: ToastrService, private dialog: MatDialog, public redirectURLService: RedirectURLService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).do((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                let data = <HttpResponse<any>>event;
                if (data != null && data.body != null) {
                    if (<boolean>data.body["isError"]) {
                       
                        for (var msg = 0; msg < data.body["messages"].length; msg++)
                        {
                            if (!data.body["messages"][msg].isSkipInterceptor) {
                                
                                this.toastr.error(data.body["messages"][msg].description);
                            }
                           
                        }                            
                    }
                    
                    if (<boolean>data.body["isNotificationSendFail"]) {
                        this.toastr.error("Notification sending failed.");
                    }
                }
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    let token = Helpers.getSessionStorage('id_token');

                    if (!token || token === '') {
                        return;
                    }

                    let model = {
                        title: "Session Expired",
                        message: "Your session will be refreshed now.", showCloseButton: false,
                        buttonOne: "Ok"
                    }

                    let dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: model, disableClose: true, width: "330px", panelClass: "crms-cd" });       

                    dialogRef.componentInstance.onSuccess.subscribe((result: boolean) => {
                        if (result) {
                            dialogRef.close();
                        }
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        //set session timeout
                        Helpers.setSessionStorage('is_session_timeout', 'true');

                        this.redirectURLService.setData(this.router.url);
                        this.router.navigate(["/auth/login"]);
                        return;
                    });
                }

                if (err.status === 403) {
                    let errObj = { error: 'Not Allowed', title: 'Error' };

                    if (err.error !== null && err.error !== undefined) {
                        errObj = JSON.parse(err.error);
                    }
                   
                    this.toastr.error(errObj.error, errObj.title);
                    return;
                }
            }
        });
    }
}


@Injectable()
export class UploadInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url === 'saveUrl') {
            const events: Observable<HttpEvent<any>>[] = [0, 30, 60, 100].map((x) => of(<HttpProgressEvent>{
                type: HttpEventType.UploadProgress,
                loaded: x,
                total: 100
            }).pipe(delay(1000)));
            const success = of(new HttpResponse({ status: 200 })).pipe(delay(1000));
            events.push(success);
            return success;
        }

        if (req.url === 'removeUrl') {
            return of(new HttpResponse({ status: 200 }));
        }

        return next.handle(req);
    }
}